import React, { useRef } from 'react'
import { Button, Modal, Form, Radio, Dropdown, Menu, Select, Space, Divider } from 'antd'
import { ExclamationCircleOutlined, DownOutlined, UpOutlined } from '@ant-design/icons'
import { PlusOutlined } from '@ant-design/icons'
import { v4 as uuid } from 'uuid'
import { IModule, moduleNames } from './util'
import JoditEditor from 'jodit-react'
import './Modules.css'

interface IProps {
  modules: IModule[]
  onSave: (modules: IModule[]) => void
}

export interface CustomWindow extends Window {
  cloudinary: any
}
declare let window: CustomWindow

export const Modules = (props: IProps) => {
  console.log('test')
  const { modules } = props

  const updateModule = (m: IModule) => {
    const newModules = modules.map((e) => (e.id === m.id ? m : e))
    props.onSave(newModules)
  }

  const openCloudinary = (m: IModule, imageSrc: 'logo' | 'carteStandard') => {
    // create the widget
    window.cloudinary
      .createUploadWidget(
        {
          cloudName: 'dohf0ighs',
          uploadPreset: 'pwkmtckx',
        },
        (error: any, result: any) => {
          if (result.event === 'success') {
            console.log(result)
            if (imageSrc === 'logo') {
              const newM = {
                ...m,
                dataPageGarde: {
                  ...m.dataPageGarde,
                  cloudinaryData: {
                    assetId: result.info.asset_id,
                    path: result.info.path,
                    secureUrl: result.info.secure_url,
                  },
                },
              }
              updateModule(newM)
            } else if (imageSrc === 'carteStandard') {
              const newM = {
                ...m,
                dataPageGarde: {
                  ...m.dataPageGarde,
                  cloudinaryDataCarteStandard: {
                    assetId: result.info.asset_id,
                    path: result.info.path,
                    secureUrl: result.info.secure_url,
                  },
                },
              }
              updateModule(newM)
            }
          }
        },
      )
      .open() // open up the widget after creation
  }
  // Information pour le package Jodit
  const editor = useRef(null)
  const config: any = {
    language: 'fr',
    readonly: false, // all options from https://xdsoft.net/jodit/doc/
    enter: 'BR',
    buttons:
      'source,bold,italic,underline,strikethrough,eraser,ul,ol,indent,outdent,align,font,fontsize,paragraph,image,table,undo,redo',
    inline: false,
    toolbarInlineForSelection: true,
    toolbarAdaptive: false,
    showPlaceholder: false,
    minHeight: '400 px',
  }
  const config_titre: any = {
    language: 'fr',
    readonly: false, // all options from https://xdsoft.net/jodit/doc/
    enter: 'BR',
    buttons:
      'source,bold,italic,underline,strikethrough,eraser,ul,ol,indent,outdent,align,font,fontsize,paragraph,image,table,undo,redo',
    inline: false,
    limitChars: 100,
    toolbarInlineForSelection: true,
    toolbarAdaptive: false,
    showPlaceholder: false,
    minHeight: '400 px',
  }

  const handleMenuClick = (e: string, m: IModule) => {
    console.log(e, m)
    if (e === 'clone') {
      const newModule = { ...m, id: uuid() }
      const newModules = modules.concat(newModule)
      props.onSave(newModules)
    } else if (e === 'delete') {
      Modal.confirm({
        title: 'Certain·e de vouloir supprimer ce module ?',
        icon: <ExclamationCircleOutlined />,
        content: 'vraiment certain·e ? ',
        onOk() {
          const newModules = modules.filter((e) => e.id !== m.id)
          props.onSave(newModules)
        },
        onCancel() {
          console.log('Cancel')
        },
      })
    }
  }

  const handleArrowUpClick = (m: IModule) => {
    const oldIndex: number = modules.map((e) => e.id).indexOf(m.id)
    const sizeModules: number = modules.length
    const newModules = modules
    if (sizeModules > 1 && oldIndex > 0) {
      newModules.splice(oldIndex - 1, 0, newModules.splice(oldIndex, 1)[0])
      props.onSave(newModules)
    }
  }

  const handleArrowDownClick = (m: IModule) => {
    const oldIndex: number = modules.map((e) => e.id).indexOf(m.id)
    const sizeModules: number = modules.length
    const newModules = modules
    if (sizeModules > 1 && oldIndex < sizeModules - 1) {
      newModules.splice(oldIndex + 1, 0, newModules.splice(oldIndex, 1)[0])
      props.onSave(newModules)
    }
  }
  // Paramètres de select dans module surfacique
  const { Option } = Select

  const listePotentiel = [{ value: 'pot_total', text: 'Total' }].concat(
    Array.from(Array(10).keys()).map((i) => ({ value: `pot${i + 1}`, text: `Potentiel ${i + 1}` })),
  )
  const listeProduits = Array.from(Array(11).keys()).map((i) => ({
    value: `pot${i}`,
    text: `Produit ${i}`,
  }))

  const listeBloc = [{ value: 'noBloc', text: 'Pas de Bloc' }].concat(
    Array.from(Array(5).keys()).map((i) => ({ value: `bloc${i + 1}`, text: `Bloc ${i + 1}` })),
  )

  return (
    <div className="adhoc-modules" style={{ marginTop: 20, borderTop: 'solid 1px #f0f0f0', paddingTop: 20 }}>
      {props.modules.map((module: IModule) => (
        <div key={module.id} style={{ marginBottom: 20 }}>
          <div className="topModule">
            <Radio.Group
              value={module.typeModule || ''}
              onChange={(e) => updateModule({ ...module, typeModule: e.target.value })}
            >
              {moduleNames.map((d) => (
                <Radio key={d.id} value={d.id}>
                  {d.name}
                </Radio>
              ))}
            </Radio.Group>
            <div>
              <div className="arrows">
                <Button
                  icon={<DownOutlined />}
                  size="small"
                  style={{ marginRight: 10 }}
                  onClick={() => handleArrowDownClick(module)}
                ></Button>
                <Button
                  icon={<UpOutlined />}
                  size="small"
                  style={{ marginRight: 10 }}
                  onClick={() => handleArrowUpClick(module)}
                ></Button>
              </div>
              <Dropdown.Button
                trigger={['click']}
                onClick={() => console.log('ok')}
                overlay={
                  <Menu onClick={(e) => handleMenuClick(e.key.toString(), module)}>
                    <Menu.Item key="clone">Cloner</Menu.Item>
                    <Menu.Item key="delete">Supprimer</Menu.Item>
                  </Menu>
                }
              ></Dropdown.Button>
            </div>
          </div>
          {/* ------------- Page de garde -------------------------------------------------          */}
          {module.typeModule === 'pageGarde' && (
            <div style={{ marginTop: 15 }}>
              {/* Logo organisation */}
              <div style={{ marginTop: 20 }}>
                <Button
                  // type="primary"
                  className="btn widget-btn"
                  onClick={() => openCloudinary(module, 'logo')}
                >
                  Charger logo organisation
                </Button>
              </div>
              <div>
                <p>L'Aperçu du Logo apparaîtra ci-dessous :</p>
                {module.dataPageGarde?.cloudinaryData && (
                  <img
                    src={module.dataPageGarde.cloudinaryData.secureUrl}
                    className="displayed-image"
                  />
                )}
              </div>

              {/* Logo prospérence  */}
              <Form.Item label="Insérer logo de Prospérences ?">
                <Radio.Group
                  value={
                    module?.dataPageGarde?.insererLogoProsperences !== undefined
                      ? module?.dataPageGarde?.insererLogoProsperences
                      : null
                  }
                  onChange={(e) => {
                    updateModule({
                      ...module,
                      dataPageGarde: {
                        ...module.dataPageGarde,
                        insererLogoProsperences: e.target.value,
                      },
                    })
                  }}
                >
                  <Radio key={'oui'} value={true}>
                    Oui
                  </Radio>
                  <Radio key={'non'} value={false}>
                    Non
                  </Radio>
                </Radio.Group>
              </Form.Item>
              {/* Titre document et nom de la zone */}
              <Form.Item label="Titre de la page de garde" style={{ marginTop: 15, maxWidth: 900 }}>
                <JoditEditor
                  ref={editor}
                  value={module?.dataPageGarde?.titre || ''}
                  config={config_titre}
                  //tabIndex={1} // tabIndex of textarea
                  onBlur={(newContent) =>
                    updateModule({
                      ...module,
                      dataPageGarde: {
                        ...module.dataPageGarde,
                        titre: newContent,
                      },
                    })
                  } // preferred to use only this option to update the content for performance reasons
                />
              </Form.Item>

              <Form.Item label="Afficher nom de la Zone ?">
                <Radio.Group
                  value={
                    module?.dataPageGarde?.zone !== undefined ? module?.dataPageGarde?.zone : null
                  }
                  onChange={(e) => {
                    updateModule({
                      ...module,
                      dataPageGarde: {
                        ...module.dataPageGarde,
                        zone: e.target.value,
                      },
                    })
                  }}
                >
                  <Radio key={'oui'} value={true}>
                    Oui
                  </Radio>
                  <Radio key={'non'} value={false}>
                    Non
                  </Radio>
                </Radio.Group>
              </Form.Item>

              {/* Zone Description */}
              <Form.Item label="Description" style={{ marginTop: 15, maxWidth: 900 }}>
                <JoditEditor
                  ref={editor}
                  value={module?.dataPageGarde?.description || ''}
                  config={config}
                  //tabIndex={1} // tabIndex of textarea
                  onBlur={(newContent) =>
                    updateModule({
                      ...module,
                      dataPageGarde: {
                        ...module.dataPageGarde,
                        description: newContent,
                      },
                    })
                  } // preferred to use only this option to update the content for performance reasons
                />
              </Form.Item>
              <Form.Item label="Insérer Carte ?">
                <Radio.Group
                  value={
                    module?.dataPageGarde?.insererCarte !== undefined
                      ? module?.dataPageGarde?.insererCarte
                      : null
                  }
                  onChange={(e) => {
                    updateModule({
                      ...module,
                      dataPageGarde: {
                        ...module.dataPageGarde,
                        insererCarte: e.target.value,
                      },
                    })
                  }}
                >
                  <Space direction="horizontal">
                    <Radio key={'oui'} value={true}>
                      Oui
                    </Radio>
                    <Radio key={'non'} value={false}>
                      Non
                    </Radio>
                  </Space>
                </Radio.Group>
              </Form.Item>
              <Form.Item>
                {module?.dataPageGarde?.insererCarte && (
                  <Radio.Group
                    style={{ marginLeft: 20 }}
                    value={
                      module?.dataPageGarde?.carteParam !== undefined
                        ? module?.dataPageGarde?.carteParam
                        : null
                    }
                    onChange={(e) => {
                      updateModule({
                        ...module,
                        dataPageGarde: {
                          ...module.dataPageGarde,
                          carteParam: e.target.value,
                        },
                      })
                    }}
                  >
                    <Radio key={'rg4'} value={'rg4'}>
                      Afficher la carte rg4
                    </Radio>
                    <Radio key={'rg5'} value={'rg5'}>
                      Afficher la carte rg5
                    </Radio>
                    <Radio key={'custom'} value={'custom'}>
                      Afficher une carte standard
                    </Radio>
                  </Radio.Group>
                )}
              </Form.Item>
              <Form.Item>
                {module?.dataPageGarde?.carteParam === 'custom' && (
                  <div>
                    <div style={{ marginTop: 20 }}>
                      <Button
                        // type="primary"
                        className="btn widget-btn"
                        onClick={() => openCloudinary(module, 'carteStandard')}
                      >
                        Charger carte standard{' '}
                      </Button>
                    </div>
                    <div>
                      <p>L'Aperçu de la carte apparaîtra ci-dessous :</p>
                      {module.dataPageGarde?.cloudinaryDataCarteStandard && (
                        <img
                          src={module.dataPageGarde.cloudinaryDataCarteStandard.secureUrl}
                          className="displayed-image"
                        />
                      )}
                    </div>
                  </div>
                )}
              </Form.Item>
            </div>
          )}
          {/* ------------- methodologie -------------------------------------------------          */}
          {module.typeModule === 'methodologie' && (
            <div>
              {/* Zone Description */}
              <Form.Item label="Description" style={{ marginTop: 15, maxWidth: 900 }}>
                <JoditEditor
                  ref={editor}
                  value={module?.dataMethodologie?.zoneTexte || ''}
                  config={config}
                  //tabIndex={1} // tabIndex of textarea
                  onBlur={(newContent) =>
                    updateModule({
                      ...module,
                      dataMethodologie: {
                        ...module.dataMethodologie,
                        zoneTexte: newContent,
                      },
                    })
                  } // preferred to use only this option to update the content for performance reasons
                />
              </Form.Item>
            </div>
          )}
          {/* ------------- surfacique -------------------------------------------------          */}
          {module.typeModule === 'surfacique' && (
            <div>
              {/* Titre document */}
              <Form.Item
                label="Titre du module surfacique"
                style={{ marginTop: 15, maxWidth: 900 }}
              >
                <JoditEditor
                  ref={editor}
                  value={module?.dataSurfacique?.titre || ''}
                  config={config_titre}
                  //tabIndex={1} // tabIndex of textarea
                  onBlur={(newContent) =>
                    updateModule({
                      ...module,
                      dataSurfacique: {
                        ...module.dataSurfacique,
                        titre: newContent,
                      },
                    })
                  } // preferred to use only this option to update the content for performance reasons
                />
              </Form.Item>

              {/* Zone Description */}
              <Form.Item label="Description" style={{ marginTop: 15, maxWidth: 900 }}>
                <JoditEditor
                  ref={editor}
                  value={module?.dataSurfacique?.zoneTexte || ''}
                  config={config}
                  //tabIndex={1} // tabIndex of textarea
                  onBlur={(newContent) =>
                    updateModule({
                      ...module,
                      dataSurfacique: {
                        ...module.dataSurfacique,
                        zoneTexte: newContent,
                      },
                    })
                  } // preferred to use only this option to update the content for performance reasons
                />
              </Form.Item>
              {/* Inserer Carte ? */}
              <Form.Item label="Insérer Carte ?">
                <Radio.Group
                  value={
                    module?.dataSurfacique?.insererCarte !== undefined
                      ? module?.dataSurfacique?.insererCarte
                      : null
                  }
                  onChange={(e) => {
                    updateModule({
                      ...module,
                      dataSurfacique: {
                        ...module.dataSurfacique,
                        insererCarte: e.target.value,
                      },
                    })
                  }}
                >
                  <Space direction="vertical">
                    <Radio key={'oui'} value={true}>
                      Oui
                    </Radio>
                    {module?.dataSurfacique?.insererCarte && (
                      <Radio.Group
                        style={{ marginLeft: 20 }}
                        value={
                          module?.dataSurfacique?.carteParam !== undefined
                            ? module?.dataSurfacique?.carteParam
                            : null
                        }
                        onChange={(e) => {
                          updateModule({
                            ...module,
                            dataSurfacique: {
                              ...module.dataSurfacique,
                              carteParam: e.target.value,
                            },
                          })
                        }}
                      >
                        <Radio key={'rg4'} value={'rg4'}>
                          Afficher la carte rg4
                        </Radio>
                        <Radio key={'rg5'} value={'rg5'}>
                          Afficher la carte rg5
                        </Radio>
                      </Radio.Group>
                    )}

                    <Radio key={'non'} value={false}>
                      Non
                    </Radio>
                  </Space>
                </Radio.Group>
              </Form.Item>
              {/* Choix potentiel */}
              <Form.Item label="Choix d'un potentiel">
                <Select
                  defaultValue={module?.dataSurfacique?.potentiel || null}
                  placeholder="potentiel"
                  onChange={(x: string) => {
                    updateModule({
                      ...module,
                      dataSurfacique: {
                        ...module.dataSurfacique,
                        potentiel: x,
                      },
                    })
                  }}
                >
                  {listePotentiel.map((x) => (
                    <Option key={x.value} value={x.value}>
                      {x.text}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              {/* Inserer Tableau ? */}
              <Form.Item label="Insérer Tableau ?">
                <Radio.Group
                  value={
                    module?.dataSurfacique?.insererTableau !== undefined
                      ? module?.dataSurfacique?.insererTableau
                      : null
                  }
                  onChange={(e) => {
                    updateModule({
                      ...module,
                      dataSurfacique: {
                        ...module.dataSurfacique,
                        insererTableau: e.target.value,
                      },
                    })
                  }}
                >
                  <Radio key={'detailed'} value={'detailed'}>
                    Détaillé
                  </Radio>
                  <Radio key={'summarized'} value={'summarized'}>
                    Résumé
                  </Radio>
                  <Radio key={'non'} value={'no'}>
                    Non
                  </Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item label="Tableau : produit à afficher ?">
                <Select
                  mode="multiple"
                  allowClear
                  style={{ width: '100%' }}
                  placeholder="produit"
                  onChange={(x: string[]) => {
                    updateModule({
                      ...module,
                      dataSurfacique: {
                        ...module.dataSurfacique,
                        tableauColonnesProduits: x,
                      },
                    })
                  }}
                  defaultValue={module?.dataSurfacique?.tableauColonnesProduits}
                >
                  {listeProduits.map((x) => (
                    <Option key={'key_1' + x.value} value={x.value}>
                      {x.text}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item label="Tableau : metrics à afficher ?">
                <Select
                  mode="multiple"
                  allowClear
                  style={{ width: '100%' }}
                  placeholder="Please select"
                  defaultValue={module?.dataSurfacique?.tableauColonnesMetrics}
                  onChange={(x: string[]) => {
                    console.log(x)
                    updateModule({
                      ...module,
                      dataSurfacique: {
                        ...module.dataSurfacique,
                        tableauColonnesMetrics: x,
                      },
                    })
                  }}
                >
                  <Option key="potentiel" value="pot_total">
                    potentiel
                  </Option>
                  <Option key="ventes" value="ventes">
                    ventes
                  </Option>
                  <Option key="pdm" value="pdm">
                    pdm
                  </Option>
                  <Option key="gain" value="gain">
                    gain
                  </Option>
                </Select>
              </Form.Item>
            </div>
          )}
          {/* ------------- ponctuel -------------------------------------------------          */}
          {module.typeModule === 'ponctuel' && (
            <div>
              {/* Titre document */}
              <Form.Item label="Titre du module ponctuel" style={{ marginTop: 15, maxWidth: 900 }}>
                <JoditEditor
                  ref={editor}
                  value={module?.dataPonctuel?.titre || ''}
                  config={config_titre}
                  //tabIndex={1} // tabIndex of textarea
                  onBlur={(newContent) =>
                    updateModule({
                      ...module,
                      dataPonctuel: {
                        ...module.dataPonctuel,
                        titre: newContent,
                      },
                    })
                  } // preferred to use only this option to update the content for performance reasons
                />
              </Form.Item>

              {/* Zone Description */}
              <Form.Item label="Description" style={{ marginTop: 15, maxWidth: 900 }}>
                <JoditEditor
                  ref={editor}
                  value={module?.dataPonctuel?.zoneTexte || ''}
                  config={config}
                  //tabIndex={1} // tabIndex of textarea
                  onBlur={(newContent) =>
                    updateModule({
                      ...module,
                      dataPonctuel: {
                        ...module.dataPonctuel,
                        zoneTexte: newContent,
                      },
                    })
                  } // preferred to use only this option to update the content for performance reasons
                />
              </Form.Item>

              {/* Inserer Carte ? */}

              {/* Inserer Carte ? */}
              <Form.Item label="Insérer Carte ?">
                <Radio.Group
                  value={
                    module?.dataPonctuel?.insererCarte !== undefined
                      ? module?.dataPonctuel?.insererCarte
                      : null
                  }
                  onChange={(e) => {
                    updateModule({
                      ...module,
                      dataPonctuel: {
                        ...module.dataPonctuel,
                        insererCarte: e.target.value,
                      },
                    })
                  }}
                >
                  <Space direction="vertical">
                    <Radio key={'oui'} value={true}>
                      Oui
                    </Radio>
                    {module?.dataPonctuel?.insererCarte && (
                      <Radio.Group
                        style={{ marginLeft: 20 }}
                        value={
                          module?.dataPonctuel?.carteParam !== undefined
                            ? module?.dataPonctuel?.carteParam
                            : null
                        }
                        onChange={(e) => {
                          updateModule({
                            ...module,
                            dataPonctuel: {
                              ...module.dataPonctuel,
                              carteParam: e.target.value,
                            },
                          })
                        }}
                      >
                        <Radio key={'rg4'} value={'rg4'}>
                          Afficher la carte rg4
                        </Radio>
                        <Radio key={'rg5'} value={'rg5'}>
                          Afficher la carte rg5
                        </Radio>
                      </Radio.Group>
                    )}

                    <Radio key={'non'} value={false}>
                      Non
                    </Radio>
                  </Space>
                </Radio.Group>
              </Form.Item>
              {/* Choix d'un BLOC */}
              <Form.Item label="Choix de la donnée Pdv (Bloc)">
                <Select
                  defaultValue={module?.dataPonctuel?.typeBloc}
                  placeholder="bloc"
                  onChange={(x: string) => {
                    updateModule({
                      ...module,
                      dataPonctuel: {
                        ...module.dataPonctuel,
                        typeBloc: x,
                        colBloc: ['raisonSociale', 'adresse', 'codePostal', 'commune'],
                      },
                    })
                  }}
                >
                  {listeBloc.map((x) => (
                    <Option key={x.value} value={x.value}>
                      {x.text}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              {module?.dataPonctuel?.typeBloc !== undefined &&
              module?.dataPonctuel?.typeBloc !== 'noBloc' ? (
                <Form.Item label="Choix des colonnes à afficher pour le bloc sélectionné">
                  <Select
                    mode="multiple"
                    allowClear
                    style={{ width: '100%' }}
                    placeholder="Please select"
                    defaultValue={module?.dataPonctuel?.colBloc}
                    onChange={(x: string[]) => {
                      console.log(x)
                      updateModule({
                        ...module,
                        dataPonctuel: {
                          ...module.dataPonctuel,
                          colBloc: x,
                        },
                      })
                    }}
                  >
                    <Option key="k5" value="enseigne">
                      Enseigne
                    </Option>
                    <Option key="k6" value="zoneChalandise">
                      Zone de Chalandise
                    </Option>
                    <Option key="k7" value="dep">
                      N° Dép
                    </Option>
                    <Option key="k8" value="raisonSociale">
                      Raison sociale
                    </Option>
                    <Option key="k9" value="adresse">
                      Adresse
                    </Option>
                    <Option key="k10" value="codePostal">
                      Code postal
                    </Option>
                    <Option key="k11" value="commune">
                      Commune
                    </Option>
                    <Option key="k12" value="tel">
                      Tél
                    </Option>
                    <Option key="k13" value="nomPrenom">
                      Nom Prénom
                    </Option>
                    <Option key="k0" value="0">
                      colonne 1
                    </Option>
                    <Option key="k1" value="1">
                      colonne 2
                    </Option>
                    <Option key="k2" value="2">
                      colonne 3
                    </Option>
                    <Option key="k3" value="3">
                      colonne 4
                    </Option>
                    <Option key="k4" value="4">
                      colonne 5
                    </Option>
                  </Select>
                </Form.Item>
              ) : null}
            </div>
          )}
          <Divider style={{ borderWidth: 5, borderColor: '#1990FF' }} />
        </div>
      ))}
      <Button
        icon={<PlusOutlined />}
        style={{ marginTop: 30 }}
        onClick={() => {
          const newModule: IModule = { id: uuid(), typeModule: undefined }
          props.onSave(modules.concat([newModule]))
        }}
      >
        Ajouter module
      </Button>
    </div>
  )
}
